var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error != null && typeof _vm.error != "undefined"
    ? _c("div", [
        typeof _vm.error == "object"
          ? _c(
              "div",
              _vm._l(_vm.error, function(singleError, index) {
                return _c(
                  "span",
                  { key: index, staticStyle: { color: "red" } },
                  [_vm._v(_vm._s(singleError))]
                )
              }),
              0
            )
          : _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(_vm._s(_vm.error))
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-036c2130", { render: render, staticRenderFns: staticRenderFns })
  }
}